<template>
	<div class="fl-cabecalho cabecalho-modelo">
		<div class="row">
			<TituloCabecalho
				:titulo="titulo"
				:sub-titulo="subTitulo"
				:submenu-modulo="submenuModulo"
				class="col-xs-12"
				:class="{'col-md-6': !exibeCadastro, 'col-md-10': exibeCadastro}"
			/>

			<div v-show="!exibeCadastro">
				<IconeCadastro :cadastro-novo="cadastroNovo" class="col-md-4 col-xs-6" />
				<BotaoVoltarCabecalho @click="clickVoltar" class="col-md-2 col-xs-12" />
			</div>

			<div v-show="exibeCadastro">
				<BotaoNovoCabecalho @click="clickNovo" class="col-md-2 col-xs-12" />
			</div>
		</div>
	</div>
</template>

<script>
import TituloCabecalho from './titulo.vue'
import IconeCadastro from './icone-cadastro.vue'
import BotaoVoltarCabecalho from './botao-voltar.vue'
import BotaoNovoCabecalho from './botao-novo.vue'
export default {
	components: {
		TituloCabecalho,
		IconeCadastro,
		BotaoVoltarCabecalho,
		BotaoNovoCabecalho
	},

	props: {
		titulo: {
			type: String,
			default: ''
		},
		subTitulo: {
			type: String,
			default: ''
		},
		exibeCadastro: {
			type: Boolean,
			default: false
		},
		cadastroNovo: {
			type: Boolean,
			default: true
		},
		rotaVoltar: {
			type: String,
			default: ''
		},
		submenuModulo: {
			type: String,
			default: 'ad'
		}
	},

	methods: {
		clickVoltar() {
			if (this.rotaVoltar) {
				this.$router.push({name: this.rotaVoltar})
			}
		},
		clickNovo() {
			this.$emit('click-novo')
		}
	}
}
</script>

<style>
.cabecalho-modelo {
	margin-bottom: 10px;
}
</style>
